export default function Loader(){

    return (
        <div class="absolute z-10 flex h-full w-full items-center justify-center bg-white bg-opacity-0">
            <div class="flex items-center">
                    <div class="h-12 w-12 animate-spin rounded-full border-y-4  border-solid border-blue-500 border-t-transparent"></div>
            </div>
        </div>
    )
}